import Container from "design-system/src/Components/Grid/Container/Container";
import FlexBox from "design-system/src/Components/FlexBox/FlexBox";
import Link from "design-system/src/Core/Link/Link";
import withDrawer, { IWithDrawerProps } from "design-system/src/HOC/withDrawer";
import React, { Suspense } from "react";
import { useTranslation } from "@src/hooks/useTranslation";
import useSocialLinks from "@src/hooks/footer/useSocialLinks";
import createModalRouteNavigation from "@src/components/general/ModalCheckoutRoute/createModalRouteNavigation";
import { WidgetGroupFieldsFragment } from "../../../../../graphql-types";
import LangSwitcher from "@src/components/general/LangSwitcher/LangSwitcher";

export interface IDefaultMenuProps extends IWithDrawerProps {
  widgetGroup: WidgetGroupFieldsFragment;
}

const WidgetGroup = React.lazy(
  () => import("@src/components/widgets/WidgetGroup/WidgetGroup")
);
const NewsletterRegister = React.lazy(
  () =>
    import("@src/components/DataDisplay/NewsletterRegister/NewsletterRegister")
);

const DefaultMenu = ({ widgetGroup }: IDefaultMenuProps) => {
  const { t } = useTranslation(["Menu"]);
  const socialLinks = useSocialLinks();

  return (
    <Container>
      <FlexBox
        direction="column"
        justify={"center"}
        style={{
          maxWidth: 386,
          margin: "0 auto",
          paddingTop: 36,
          paddingBottom: 36,
          color: "#1b1a16",
        }}
      >
        <FlexBox direction="column" gap={74}>
          <LangSwitcher />
          <Suspense>
            <WidgetGroup group={widgetGroup} />
          </Suspense>

          <Suspense>
            <NewsletterRegister
              mode="light"
              title={t("Recevez nos actualités", "Menu")}
            />
          </Suspense>

          <FlexBox gap={16}>
            {socialLinks.map((link, index) => {
              const { label, ...restL } = link;
              return (
                <Link
                  key={index}
                  variant="h4"
                  color="champagne7"
                  label=""
                  {...restL}
                />
              );
            })}
          </FlexBox>
        </FlexBox>
      </FlexBox>
    </Container>
  );
};

DefaultMenu.displayName = "DefaultMenu";

export const DefaultMenuDrawer = withDrawer<
  IDefaultMenuProps & IWithDrawerProps
>(DefaultMenu, {
  forceRender: false,
  closable: true,
  extraContent: createModalRouteNavigation(),
});

DefaultMenuDrawer.displayName = "DefaultMenuDrawer";

export default DefaultMenu;
